import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Grid,
  IconButton,
  Button,
  Paper,
} from "@mui/material";
import {
  transactionClicked,
  orgClicked,
  transactionDetail,
  showloader,
} from "../store/gloabalState";
import { useRecoilState, useSetRecoilState } from "recoil";
import { DateConvert } from "../utils/dateConverter";
import { Link, useParams } from "react-router-dom";
import { saveAs } from "file-saver";
import NotFound from "./notfound";
import {
  getTransactionsDetail,
  getOrgsDetails,
  getDownloadDoc,
  getCheckList,
} from "../services/httpCalls";
import PreviewDoc from "../components/previewDoc";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import TransactionDownloadDocs from "../components/TransactionDownloadDocs";
import ChatsModal from "../components/chats";
import DraftsApproval from "../components/DraftsApproval";
export default function DetailTransaction() {
  const [transactionId, setTransactionId] = useRecoilState(transactionClicked);
  const [transactionDetails, setTransactionDetails] =
    useRecoilState(transactionDetail);
  const [showNotFound, setShowNotFound] = useState(false);
  const setShowLoader = useSetRecoilState(showloader);
  const [userID, setUserID] = useState();
  const [orgID, setOrgId] = useState();
  const [users, setUser] = useState();
  const [showPreview, setShowPreview] = useState(false);
  const [hidePreviewEsign, setHidePreviewEsign] = useState(false);
  const [orgDetails, setOrgDetails] = useRecoilState(orgClicked);
  const [checkList, setChecklist] = useState([]);
  const [showChats, setShowChats] = useState(false);
  const [activeChat, setActiveChat] = useState("");
  const [activeCompanyId, setActiveCompanyId] = useState("");
  let params = useParams();
  const getOrgDetails = async (userID, orgID) => {
    getOrgsDetails(orgID).then((res) => {
      setOrgDetails(res);
      let userList = res?.userList;
      userList?.forEach((value) => {
        if (value.id === userID) {
          setUser(value);
        }
      });
      setShowLoader(false);
    });
  };

  useEffect(() => {
    async function getTransactionDetail(transactionId) {
      setShowLoader(true);
      if (transactionId) {
        getTransactionsDetail(transactionId)
          .then((res) => {
            setTransactionDetails(res);
            if (res.docEsignStatus === "SIGNED") {
              setHidePreviewEsign(true);
            }
            setShowNotFound(false);
            setOrgId(res?.organisationId);
            setUserID(res?.userId);
            getOrgDetails(res?.userId, res?.organisationId);
          })
          .catch((error) => {
            if (error.code === "ERR_BAD_REQUEST") {
              setShowNotFound(true);
            }
            setShowLoader(false);
          });
      } else {
        let url = window.location.pathname;
        let id = params.id;
        url = url.split("/");
        url = url[2];
        setTransactionId(url);
        getTransactionsDetail(url);
      }
    }
    getTransactionDetail(transactionId);
  }, [transactionId]);

  const downloadDoc = async () => {
    if (transactionId) {
      getDownloadDoc(transactionId).then((res) => {
        saveAs(res.message, "download.zip");
      });
    }
  };
  useEffect(() => {
    const showCheckList = async (txnId) => {
      if (transactionId) {
        await getCheckList(txnId)
          .then((res) => {
            setChecklist(res);
          })
          .catch((err) => {
            console.log(err);
          });
      }
    };
    showCheckList(transactionId);
  }, [transactionId]);

  return (
    <Box sx={{ padding: "1rem" }}>
      <Box sx={{ display: "flex", alignItems: "center" }}>
        <Typography
          variant="h5"
          sx={{ paddingBottom: "1rem", fontWeight: 400 }}
        >
          Details of Transaction ID (<b>{transactionId}</b>)
        </Typography>
        {!showNotFound && (
          <Button
            variant="contained"
            LinkComponent={Link}
            to={`/update/${transactionId}`}
            sx={{ marginLeft: "auto" }}
            disabled={transactionDetails.stage === "DROPPED" ? true : false}
          >
            Edit
          </Button>
        )}
      </Box>
      {showNotFound ? (
        <NotFound />
      ) : (
        <>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <Box
                sx={{
                  padding: ".5rem 0",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <Typography variant="p" sx={{ fontWeight: 400, fontSize: 14 }}>
                  Customer Name:
                </Typography>
                <Typography
                  variant="p"
                  sx={{ fontWeight: 500, fontSize: 16, paddingLeft: ".5rem" }}
                >
                  {transactionDetails?.customerName
                    ? transactionDetails.customerName
                    : "-"}
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={6}>
              <Box
                sx={{
                  padding: ".5rem 0",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <Typography variant="p" sx={{ fontWeight: 400, fontSize: 14 }}>
                  Vendor Name:
                </Typography>
                <Typography
                  variant="p"
                  sx={{ fontWeight: 500, fontSize: 16, paddingLeft: ".5rem" }}
                >
                  {transactionDetails?.vendorName
                    ? transactionDetails.vendorName
                    : "-"}
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={6}>
              <Box
                sx={{
                  padding: ".5rem 0",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <Typography variant="p" sx={{ fontWeight: 400, fontSize: 14 }}>
                  Initiation Date:
                </Typography>
                <Typography
                  variant="p"
                  sx={{ fontWeight: 500, fontSize: 16, paddingLeft: ".5rem" }}
                >
                  {transactionDetails?.initiationDate
                    ? DateConvert(transactionDetails?.initiationDate)
                    : "-"}
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={6}>
              <Box
                sx={{
                  padding: ".5rem 0",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <Typography variant="p" sx={{ fontWeight: 400, fontSize: 14 }}>
                  Proposed Date:
                </Typography>
                <Typography
                  variant="p"
                  sx={{ fontWeight: 500, fontSize: 16, paddingLeft: ".5rem" }}
                >
                  {transactionDetails?.purposedDateOfPayment
                    ? DateConvert(transactionDetails?.purposedDateOfPayment)
                    : "-"}
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={6}>
              <Box
                sx={{
                  padding: ".5rem 0",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <Typography variant="p" sx={{ fontWeight: 400, fontSize: 14 }}>
                  Current Stage:
                </Typography>
                <Typography
                  variant="p"
                  sx={{ fontWeight: 500, fontSize: 16, paddingLeft: ".5rem" }}
                >
                  {transactionDetails?.stage ? transactionDetails.stage : "-"}
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={6}>
              <Box
                sx={{
                  padding: ".5rem 0",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <Typography variant="p" sx={{ fontWeight: 400, fontSize: 14 }}>
                  Currency:
                </Typography>
                <Typography
                  variant="p"
                  sx={{ fontWeight: 500, fontSize: 16, paddingLeft: ".5rem" }}
                >
                  {transactionDetails?.currencyCode
                    ? transactionDetails.currencyCode
                    : "-"}
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={6}>
              <Box
                sx={{
                  padding: ".5rem 0",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <Typography variant="p" sx={{ fontWeight: 400, fontSize: 14 }}>
                  Amount:
                </Typography>
                <Typography
                  variant="p"
                  sx={{ fontWeight: 500, fontSize: 16, paddingLeft: ".5rem" }}
                >
                  {transactionDetails?.amount ? transactionDetails?.amount: "-"}
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={6}>
              <Box
                sx={{
                  padding: ".5rem 0",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <Typography variant="p" sx={{ fontWeight: 400, fontSize: 14 }}>
                  CA Selected:
                </Typography>
                <Typography
                  variant="p"
                  sx={{ fontWeight: 500, fontSize: 16, paddingLeft: ".5rem" }}
                >
                  {transactionDetails?.charteredAccountantName
                    ? transactionDetails.charteredAccountantName
                    : "-"}
                </Typography>
              </Box>
            </Grid>

            <Grid item xs={6}>
              <Box
                sx={{
                  padding: ".5rem 0",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <Typography variant="p" sx={{ fontWeight: 400, fontSize: 14 }}>
                  Completed Date:
                </Typography>
                <Typography
                  variant="p"
                  sx={{ fontWeight: 500, fontSize: 16, paddingLeft: ".5rem" }}
                >
                  {transactionDetails?.stage === "COMPLETED" && transactionDetails?.lastUpdatedDate
                    ? DateConvert(transactionDetails?.lastUpdatedDate)
                    : "-"}
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={6}>
              <Box
                sx={{
                  padding: ".5rem 0",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <Typography variant="p" sx={{ fontWeight: 400, fontSize: 14 }}>
                  Purpose of transaction:
                </Typography>
                <Typography
                  variant="p"
                  sx={{ fontWeight: 500, fontSize: 16, paddingLeft: ".5rem" }}
                >
                  {transactionDetails?.purposeDescriptionAsPerRBI
                    ? transactionDetails.purposeDescriptionAsPerRBI
                    : "-"}
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={6}>
              <Box
                sx={{
                  padding: ".5rem 0",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <Typography variant="p" sx={{ fontWeight: 400, fontSize: 14 }}>
                  Purpose code:
                </Typography>
                <Typography
                  variant="p"
                  sx={{ fontWeight: 500, fontSize: 16, paddingLeft: ".5rem" }}
                >
                  {transactionDetails?.purposeCodeAsPerRBI
                    ? transactionDetails.purposeCodeAsPerRBI
                    : "-"}
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={6}>
              <Box
                sx={{
                  padding: ".5rem 0",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <Typography variant="p" sx={{ fontWeight: 400, fontSize: 14 }}>
                  UTR:
                </Typography>
                <Typography
                  variant="p"
                  sx={{ fontWeight: 500, fontSize: 16, paddingLeft: ".5rem" }}
                >
                  {transactionDetails?.utr ? transactionDetails.utr : "-"}
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={6}>
              <Box
                sx={{
                  padding: ".5rem 0",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <Typography variant="p" sx={{ fontWeight: 400, fontSize: 14 }}>
                  UDIN:
                </Typography>
                <Typography
                  variant="p"
                  sx={{ fontWeight: 500, fontSize: 16, paddingLeft: ".5rem" }}
                >
                  {transactionDetails?.udin ? transactionDetails.udin : "-"}
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={6}>
              <Box
                sx={{
                  padding: ".5rem 0",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <Typography variant="p" sx={{ fontWeight: 400, fontSize: 14 }}>
                  Status of 15cb:
                </Typography>
                <Typography
                  variant="p"
                  sx={{ fontWeight: 500, fontSize: 16, paddingLeft: ".5rem" }}
                >
                  {transactionDetails?.statusCaStage?.replaceAll("_", " ")}
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={6}>
              <Box
                sx={{
                  padding: ".5rem 0",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <Typography variant="p" sx={{ fontWeight: 400, fontSize: 14 }}>
                  Status of Esign:
                </Typography>
                <Typography
                  variant="p"
                  sx={{ fontWeight: 500, fontSize: 16, paddingLeft: ".5rem" }}
                >
                  {transactionDetails?.docEsignStatus
                    ? transactionDetails.docEsignStatus
                    : "Not Initiated"}
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={6}>
              <Box
                sx={{
                  padding: ".5rem 0",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <Typography variant="p" sx={{ fontWeight: 400, fontSize: 14 }}>
                  Bank Stage Status:
                </Typography>
                <Typography
                  variant="p"
                  sx={{ fontWeight: 500, fontSize: 16, paddingLeft: ".5rem" }}
                >
                  {transactionDetails?.bankStageStatus
                    ? transactionDetails.bankStageStatus
                    : "-"}
                </Typography>
              </Box>
            </Grid>

            <Grid item xs={6}>
              <Box
                sx={{
                  padding: "",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <Typography variant="p" sx={{ fontWeight: 400, fontSize: 14 }}>
                  Download Documents:
                </Typography>
                <IconButton color="primary" variant="contained">
                  <TransactionDownloadDocs downloadDoc={downloadDoc} />
                </IconButton>
              </Box>

            </Grid>
            <Grid item xs={6}>
              <Box
                sx={{
                  padding: ".5rem 0",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <Typography variant="p" sx={{ fontWeight: 400, fontSize: 14 }}>
                  Bank Name:
                </Typography>
                <Typography
                  variant="p"
                  sx={{ fontWeight: 500, fontSize: 16, paddingLeft: ".5rem" }}
                >
                  {transactionDetails?.bankName
                    ? transactionDetails.bankName
                    : "-"}
                </Typography>
              </Box>
            </Grid>
          </Grid>

          <Grid container sx={{ marginBottom: "1rem", marginTop: "1rem" }}>
            <Grid item xs={5}>
              <Box
                sx={{
                  padding: ".5rem 0",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <Typography variant="h5" sx={{ fontWeight: 400 }}>
                  Details of Initiator
                </Typography>
              </Box>
              <Grid item xs={6}>
                <Box
                  sx={{
                    padding: ".5rem 0",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <Typography
                    variant="p"
                    sx={{ fontWeight: 400, fontSize: 14 }}
                  >
                    Name:
                  </Typography>
                  <Typography
                    variant="p"
                    sx={{ fontWeight: 500, fontSize: 16, paddingLeft: ".5rem" }}
                  >
                    {users?.name ? users?.name : "-"}
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={6}>
                <Box
                  sx={{
                    padding: ".5rem 0",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <Typography
                    variant="p"
                    sx={{ fontWeight: 400, fontSize: 14 }}
                  >
                    Phone:
                  </Typography>
                  <Typography
                    variant="p"
                    sx={{ fontWeight: 500, fontSize: 16, paddingLeft: ".5rem" }}
                  >
                    {users?.phoneNumber ? users?.phoneNumber : "-"}
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={6}>
                <Box
                  sx={{
                    padding: ".5rem 0",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <Typography
                    variant="p"
                    sx={{ fontWeight: 400, fontSize: 14 }}
                  >
                    Email:
                  </Typography>
                  <Typography
                    variant="p"
                    sx={{ fontWeight: 500, fontSize: 16, paddingLeft: ".5rem" }}
                  >
                    {users?.email ? users?.email : "-"}
                  </Typography>
                </Box>
              </Grid>
            </Grid>
          </Grid>
        </>
      )}
      <Grid container sx={{ marginBottom: "4rem" }} xs={12}>
        <Paper
          sx={{
            borderRadius: "15px",
            width: "100%",

            mb: 2,
          }}
          elevation={2}
        >
          <Box
            sx={{
              padding: ".5rem 0",
              display: "flex",
              alignItems: "center",
              width: "100%",
              background: "#000",
              color: "#fff",
              borderRadius: "4px 4px 4px 4px",
            }}
          >
            <Typography
              sx={{ fontWeight: 540, p: 1, ml: 2, fontSize: "1.2rem" }}
            >
              Check List
            </Typography>
          </Box>

          <Grid
            item
            xs={12}
            sx={{
              p: 2,
            }}
          >
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <Box
                  sx={{
                    padding: ".5rem 0",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <Typography
                    variant="p"
                    sx={{ fontWeight: 500, fontSize: 14 }}
                  >
                    UDIN for 15CB:
                  </Typography>
                  <Typography
                    variant="p"
                    sx={{
                      fontWeight: 700,
                      fontSize: 17,
                      paddingLeft: ".2rem",
                    }}
                  >
                    {checkList.udin ? checkList.udin : "-"}
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={6}>
                <Box
                  sx={{
                    padding: ".5rem 0",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <Typography
                    variant="p"
                    sx={{ fontWeight: 500, fontSize: 14 }}
                  >
                    LEI of remitter:
                  </Typography>
                  <Typography
                    variant="p"
                    sx={{
                      fontWeight: 700,
                      fontSize: 17,
                      paddingLeft: ".5rem",
                    }}
                  >
                    {checkList.leiRemitter ? checkList.leiRemitter : "-"}
                  </Typography>
                </Box>
              </Grid>

              <Grid item xs={6}>
                <Box
                  sx={{
                    padding: ".5rem 0",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <Typography
                    variant="p"
                    sx={{ fontWeight: 500, fontSize: 14 }}
                  >
                    A2 form:
                  </Typography>
                  <Typography
                    variant="p"
                    sx={{
                      fontWeight: 700,
                      fontSize: 17,
                      paddingLeft: ".5rem",
                    }}
                  >
                    {checkList.formA2 ? checkList.formA2 : "-"}
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={6}>
                <Box
                  sx={{
                    padding: ".5rem 0",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <Typography
                    variant="p"
                    sx={{ fontWeight: 500, fontSize: 14 }}
                  >
                    LEI of Beneficiary:
                  </Typography>
                  <Typography
                    variant="p"
                    sx={{
                      fontWeight: 700,
                      fontSize: 17,
                      paddingLeft: ".5rem",
                    }}
                  >
                    {checkList.leiBeneficiary ? checkList.leiBeneficiary : "-"}
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={6}>
                <Box
                  sx={{
                    padding: ".5rem 0",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <Typography
                    variant="p"
                    sx={{
                      fontWeight: 500,
                      fontSize: 14,
                    }}
                  >
                    15CB:
                  </Typography>
                  <Typography
                    variant="p"
                    sx={{
                      fontWeight: 700,
                      fontSize: 17,
                      paddingLeft: ".5rem",
                    }}
                  >
                    {checkList["15CB"] ? checkList["15CB"] : ""}
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={6}>
                <Box
                  sx={{
                    padding: ".5rem 0",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <Typography
                    variant="p"
                    sx={{
                      fontWeight: 500,
                      fontSize: 14,
                    }}
                  >
                    15CA:
                  </Typography>
                  <Typography
                    variant="p"
                    sx={{
                      fontWeight: 700,
                      fontSize: 17,
                      paddingLeft: ".5rem",
                    }}
                  >
                    {checkList["15CA"] ? checkList["15CA"] : "-"}
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={6}>
                <Box
                  sx={{
                    padding: ".5rem 0",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <Typography
                    variant="p"
                    sx={{ fontWeight: 500, fontSize: 14 }}
                  >
                    Balance sheet:
                  </Typography>
                  <Typography
                    variant="p"
                    sx={{
                      fontWeight: 700,
                      fontSize: 17,
                      paddingLeft: ".5rem",
                    }}
                  >
                    {checkList.BalSheet ? checkList.BalSheet : "-"}
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={6}>
                <Box
                  sx={{
                    padding: ".5rem 0",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <Typography
                    variant="p"
                    sx={{ fontWeight: 500, fontSize: 14 }}
                  >
                    Bank statement:
                  </Typography>
                  <Typography
                    variant="p"
                    sx={{
                      fontWeight: 700,
                      fontSize: 17,
                      paddingLeft: ".5rem",
                    }}
                  >
                    {checkList.bankStatment ? checkList.bankStatment : "-"}
                  </Typography>
                </Box>
              </Grid>

              <Grid item xs={6}>
                <Box
                  sx={{
                    padding: ".5rem 0",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <Typography
                    variant="p"
                    sx={{ fontWeight: 500, fontSize: 14 }}
                  >
                    Not an advance payment:
                  </Typography>
                  <Typography
                    variant="p"
                    sx={{
                      fontWeight: 700,
                      fontSize: 17,
                      paddingLeft: ".5rem",
                    }}
                  >
                    {checkList.isAdvcPay ? checkList.isAdvcPay : "-"}
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={6}>
                <Box
                  sx={{
                    padding: ".5rem 0",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <Typography
                    variant="p"
                    sx={{ fontWeight: 500, fontSize: 14 }}
                  >
                    Agreement available or not :
                  </Typography>
                  <Typography
                    variant="p"
                    sx={{
                      fontWeight: 700,
                      fontSize: 17,
                      paddingLeft: ".5rem",
                    }}
                  >
                    {checkList.isAgreementAvail
                      ? checkList.isAgreementAvail
                      : "-"}
                  </Typography>
                </Box>
              </Grid>

              <Grid item xs={6}>
                <Box
                  sx={{
                    padding: ".5rem 0",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <Typography
                    variant="p"
                    sx={{ fontWeight: 500, fontSize: 14 }}
                  >
                    Transaction invoice with sign and stamp:
                  </Typography>
                  <Typography
                    variant="p"
                    sx={{
                      fontWeight: 700,
                      fontSize: 17,
                      paddingLeft: ".5rem",
                    }}
                  >
                    {checkList.tranInvoice ? checkList.tranInvoice : "-"}
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={6}>
                <Box
                  sx={{
                    padding: ".5rem 0",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <Typography
                    variant="p"
                    sx={{ fontWeight: 500, fontSize: 14 }}
                  >
                    Remitter CIF to be available at SBM:
                  </Typography>
                  <Typography
                    variant="p"
                    sx={{
                      fontWeight: 700,
                      fontSize: 17,
                      paddingLeft: ".5rem",
                    }}
                  >
                    {checkList.remitterCif ? checkList.remitterCif : "-"}
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={6}>
                <Box
                  sx={{
                    padding: ".5rem 0",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <Typography
                    variant="p"
                    sx={{ fontWeight: 500, fontSize: 14 }}
                  >
                    Transaction velocity within the approved limits:
                  </Typography>
                  <Typography
                    variant="p"
                    sx={{
                      fontWeight: 700,
                      fontSize: 17,
                      paddingLeft: "0.2rem",
                    }}
                  >
                    {checkList.tranVelocity ? checkList.tranVelocity : "-"}
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={6}>
                <Box
                  sx={{
                    padding: ".5rem 0",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <Typography
                    variant="p"
                    sx={{
                      fontWeight: 500,
                      fontSize: 14,
                    }}
                  >
                    Purpose of transaction to be from the list of allowed
                    transactions:
                  </Typography>
                  <Typography
                    variant="p"
                    sx={{
                      fontWeight: 700,
                      fontSize: 17,
                      paddingLeft: ".3rem",
                    }}
                  >
                    {checkList.purposeOfTransaction
                      ? checkList.purposeOfTransaction
                      : "-"}
                  </Typography>
                </Box>
              </Grid>
            </Grid>
          </Grid>
        </Paper>
      </Grid>
      {transactionDetails.stage === "DROPPED" ? (
        <></>
      ) : (
        <>
          <Box className="btn_wrap_bottom">
            {transactionDetails.stage === "DROPPED" ? <></> : <></>}
            {transactionDetails.stage === "CB15" && (
              <Button variant="text">
                <DraftsApproval />
              </Button>
            )}

            {orgDetails?.charteredAccountantChoice?.toUpperCase !== "OWN" &&
              transactionDetails.stage !== "INITIATED" && (
                <Button
                  variant="contained"
                  onClick={() => (
                    setShowChats(true),
                    setActiveChat("ca"),
                    setActiveCompanyId(
                      transactionDetails.charteredAccountantFirmId
                    )
                  )}
                  sx={{ marginRight: "1rem" }}
                >
                  Chat with CA
                </Button>
              )}
            {(transactionDetails.stage === "TRANSACTION_INITIATED" ||
              transactionDetails.stage === "FUND_REQUESTED" ||
              transactionDetails.stage === "APPROVED" ||
              transactionDetails.stage === "COMPLETED") && (
              <Button
                variant="contained"
                onClick={() => (
                  setShowChats(true),
                  setActiveChat("bank"),
                  setActiveCompanyId(
                    transactionDetails.adBankId
                      ? transactionDetails.adBankId
                      : ""
                  )
                )}
                sx={{ marginRight: "1rem" }}
              >
                Chat with Bank
              </Button>
            )}
            {!hidePreviewEsign && (
              <Button
                variant="contained"
                onClick={(e) => setShowPreview(true)}
                sx={{ backgroundColor: "#dc1d00" }}
              >
                <PictureAsPdfIcon sx={{ marginRight: ".5rem" }} />
                Process Document
              </Button>
            )}
          </Box>
          {showPreview && <PreviewDoc setShowPreview={setShowPreview} />}
          <ChatsModal
            activeChat={activeChat}
            showChats={showChats}
            setShowChats={setShowChats}
            traxId={transactionId}
            firmId={activeCompanyId}
          />
        </>
      )}
    </Box>
  );
}
